import { render, staticRenderFns } from "./RegistroResultadosAspiranteDialogComponent.vue?vue&type=template&id=0eb4052c&scoped=true"
import script from "./RegistroResultadosAspiranteDialogComponent.vue?vue&type=script&lang=js"
export * from "./RegistroResultadosAspiranteDialogComponent.vue?vue&type=script&lang=js"
import style0 from "./RegistroResultadosAspiranteDialogComponent.vue?vue&type=style&index=0&id=0eb4052c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eb4052c",
  null
  
)

export default component.exports